import { render, staticRenderFns } from "./order-steps.component.vue?vue&type=template&id=61d46acb"
import script from "./order-steps.component.ts?vue&type=script&lang=ts&external"
export * from "./order-steps.component.ts?vue&type=script&lang=ts&external"
import style0 from "./order-steps.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports